import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader-block ml-auto demo" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-xl-12" }
const _hoisted_6 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_7 = { class: "panel-container show" }
const _hoisted_8 = { class: "panel-content contents" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_11 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_12 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_15 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-xl-12" }
const _hoisted_21 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_22 = { class: "panel-container show" }
const _hoisted_23 = { class: "panel-content" }
const _hoisted_24 = {
  key: 0,
  class: "gtablecell btnDetCell"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 3 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 4 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { key: 5 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 6 }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 7 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 8 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { key: 9 }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { key: 10 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 11 }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 12 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "gtablecell"
}
const _hoisted_52 = {
  key: 2,
  class: "gtablecell"
}
const _hoisted_53 = {
  key: 3,
  class: "gtablecell"
}
const _hoisted_54 = {
  key: 4,
  class: "gtablecell"
}
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = {
  key: 5,
  class: "gtablecell"
}
const _hoisted_57 = {
  key: 6,
  class: "gtablecell"
}
const _hoisted_58 = {
  key: 7,
  class: "gtablecell"
}
const _hoisted_59 = {
  key: 8,
  class: "gtablecell"
}
const _hoisted_60 = {
  key: 9,
  class: "gtablecell"
}
const _hoisted_61 = {
  key: 10,
  class: "gtablecell"
}
const _hoisted_62 = {
  key: 11,
  class: "gtablecell"
}
const _hoisted_63 = { style: {"max-height":"65vh","overflow-y":"auto"} }
const _hoisted_64 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "申請書一覧")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary waves-effect waves-themed",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl()))
        }, _cache[23] || (_cache[23] = [
          _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
          _createTextVNode("Excel出力 ")
        ])),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary waves-effect waves-themed",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal()))
        }, _cache[24] || (_cache[24] = [
          _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
          _createTextVNode("申請書作成 ")
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "検索条件"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      name: "start",
                      min: "0",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.domIdStart) = $event)),
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getlist(1)), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.domIdStart]
                    ])
                  ])
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請種類", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opRequestType,
                    modelValue: _ctx.domReqType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.domReqType) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "ステータス", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opRequsetStatus,
                    modelValue: _ctx.domReqState,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.domReqState) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "承認者", -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegate4list.items4staffsSortNum,
                    label: "c_staff_name",
                    modelValue: _ctx.domAuthorizerId,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.domAuthorizerId) = $event)),
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.delegate4list.items4staffsSortNum,
                    label: "c_staff_name",
                    modelValue: _ctx.domApplicantId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.domApplicantId) = $event)),
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary waves-effect waves-themed btn-search mx-auto",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getlist(1)))
                }, " 検索 ")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "条件結果"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_22, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_vue_good_table, {
                mode: "remote",
                onPageChange: _ctx.onPageChange,
                onSortChange: _ctx.onSortChange,
                columns: _ctx.columns,
                rows: _ctx.delegate.items,
                "sort-options": {
                  enabled: false,
                },
                "pagination-options": {
                  perPageDropdownEnabled: false,
                  enabled: true,
                  jumpFirstOrLast: false,
                  nextLabel: '次へ',
                  prevLabel: '前へ',
                  mode: 'pages',
                  ofLabel: '/',
                  pageLabel: '',
                },
                totalRows: _ctx.delegate.pager.maxcount
              }, {
                "table-row": _withCtx((props) => [
                  (props.column.field == 'btnDet')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (props.row.c_request_type == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_karibaraiedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_26)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Zangyoedit?id=' + props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_28)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Remoteworkedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_30)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Shutchoedit?id=' + props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_32)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 5)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Settaiedit?id=' + props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_34)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 6)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Shayoshashiyoedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_36)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 7)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Keihiseisanedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_38)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 8)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Kyukatodokeedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_40)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 9)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Ringishoedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_42)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Kyushokunegaiedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_44)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 11)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Kyuyoshoyokozatorokuedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_46)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 12)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Jushohenkotsukinteateedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_48)
                            ]))
                          : _createCommentVNode("", true),
                        (props.row.c_request_type == 13)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-xs btn-primary waves-effect waves-themed",
                                onClick: ($event: any) => (
                          _ctx.goTo(
                            '/shinsei_Keihikozatorokuedit?id=' +
                              props.row.c_request_id,
                            $event
                          )
                        )
                              }, " 詳細 ", 8, _hoisted_50)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (props.column.field == 'c_request_type')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.cnvReqType2Name(props.formattedRow[props.column.field])), 1))
                      : (props.column.field == 'c_staff_id')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                        : (props.column.field == 'c_request_datetime')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.cnvDate(props.formattedRow[props.column.field])), 1))
                          : (props.column.field == 'c_request_status')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createElementVNode("div", {
                                  style: {"text-align":"center"},
                                  innerHTML: 
                        _ctx.cnvStatusNum2Name(
                          props.formattedRow[props.column.field]
                        )
                      
                                }, null, 8, _hoisted_55)
                              ]))
                            : (props.column.field == 'c_request_1_approval')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                              : (props.column.field == 'c_request_2_approval')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                                : (props.column.field == 'c_request_3_approval')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.cnvStaffId2Name(props.formattedRow[props.column.field])), 1))
                                  : (
                      props.column.field == 'c_request_1_approval_datetime'
                    )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.getApprovalDate(
                        props.formattedRow[props.column.field],
                        props.formattedRow["c_request_1_approval"]
                      )), 1))
                                    : (
                      props.column.field == 'c_request_2_approval_datetime'
                    )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.getApprovalDate(
                        props.formattedRow[props.column.field],
                        props.formattedRow["c_request_2_approval"]
                      )), 1))
                                      : (
                      props.column.field == 'c_request_3_approval_datetime'
                    )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.getApprovalDate(
                        props.formattedRow[props.column.field],
                        props.formattedRow["c_request_3_approval"]
                      )), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(props.formattedRow[props.column.field]), 1))
                ]),
                _: 1
              }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_l, { ref: "Mo_modal_selectType" }, {
      title: _withCtx(() => _cache[35] || (_cache[35] = [
        _createTextVNode("申請書選択")
      ])),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/shinsei_Zangyoedit')))
          }, _cache[36] || (_cache[36] = [
            _createElementVNode("span", null, "時間外残業申請書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push('/shinsei_Kyukatodokeedit')))
          }, _cache[37] || (_cache[37] = [
            _createElementVNode("span", null, "休暇届", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/shinsei_Shutchoedit')))
          }, _cache[38] || (_cache[38] = [
            _createElementVNode("span", null, "出張申請書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/shinsei_Settaiedit')))
          }, _cache[39] || (_cache[39] = [
            _createElementVNode("span", null, "接待申請書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/shinsei_Shayoshashiyoedit')))
          }, _cache[40] || (_cache[40] = [
            _createElementVNode("span", null, "業務用車両の使用許可届", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push('/shinsei_karibaraiedit')))
          }, _cache[41] || (_cache[41] = [
            _createElementVNode("span", null, "仮払申請書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/shinsei_Keihiseisanedit')))
          }, _cache[42] || (_cache[42] = [
            _createElementVNode("span", null, "経費精算書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-up",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$router.push('/shinsei_Ringishoedit')))
          }, _cache[43] || (_cache[43] = [
            _createElementVNode("span", null, "稟議書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/shinsei_Kyushokunegaiedit')))
          }, _cache[44] || (_cache[44] = [
            _createElementVNode("span", null, "休職願", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.push('/shinsei_Kyuyoshoyokozatorokuedit')))
          }, _cache[45] || (_cache[45] = [
            _createElementVNode("span", null, "給与・賞与振込口座登録依頼書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$router.push('/shinsei_Jushohenkotsukinteateedit')))
          }, _cache[46] || (_cache[46] = [
            _createElementVNode("span", null, "住所変更及び通勤手当申請書", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success btn-block waves-effect waves-themed modalcolor-down",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$router.push('/shinsei_Keihikozatorokuedit')))
          }, _cache[47] || (_cache[47] = [
            _createElementVNode("span", null, "経費振込口座登録依頼書", -1)
          ])),
          _cache[48] || (_cache[48] = _createElementVNode("span", { class: "color-danger-600" }, "※緑色の申請書は紙での提出が必要な申請書です", -1))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.closeModal()))
        }, " 閉じる ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[49] || (_cache[49] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[50] || (_cache[50] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("button", {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}